import { useQuery } from '@tanstack/react-query'

import { queryClientOptions } from '../../../../../provider'
import type { UseAppQueryOptions } from '../../../../../types'
import type { FetchMembershipContractsEligibleForDPAEOptions } from '../membership.contract.api'
import { fetchMembershipContractsEligibleForDPAE } from '../membership.contract.api'
import { membershipContractCacheKeys } from '../membership.contract.cacheKeys'
import type { MembershipContractEligibleForDPAESchema } from '../types/membership.contract.schema'

export const useFetchMembershipContractEligibleForDPAE = (
  request: FetchMembershipContractsEligibleForDPAEOptions,
  queryOptions?: UseAppQueryOptions<MembershipContractEligibleForDPAESchema>
) => {
  return useQuery({
    ...queryOptions,
    queryKey:
      membershipContractCacheKeys.fetch_contracts_eligible_for_dpae(request),
    queryFn: () => fetchMembershipContractsEligibleForDPAE(request),
    staleTime: queryClientOptions.time.STATIC
  })
}
